import { SectionRowViewModelSizeAndQuantity } from './section-row-view-model-size-and-quantity';

export class SectionRowViewModelKillerQueen extends SectionRowViewModelSizeAndQuantity {}
